<template>
  <el-dialog
    :visible.sync="exhaustFanGroupDialogVisible"
    width="952px"
    top="4vh"
    :before-close="closeExhaustFanDialog"
  >
    <template slot="title"> <title-icon />新风机交换系统 </template>
    <div class="content">
      <div style="height: 216px">
        <div style="float: left; padding: 20px; width: 50%">
          <img src="../../../../../../../assets/images/speed-wind.png" />
          <p>
            <span style="margin-left: 20px; margin-right: 10px">运行状态:</span>
            <template v-if="monitorType11025 == 'true'">
              <span class="statusClass autoHand"> 运行 </span>
            </template>
            <template v-else>
              <span class="statusClass stop"> 停止</span>
            </template>
          </p>
        </div>
        <div style="float: left; width: 50%; height: 216px">
          <div class="collectingWell-c-r speedWind-c-r fl">
            <div>
              <span class="titleClass">手自动状态</span>
              <template v-if="monitorType013001 == 'true'">
                <span class="statusClass autoHand"> 自动 </span>
              </template>
              <template v-else>
                <span class="statusClass stop"> 手动 </span>
              </template>
            </div>
            <div>
              <span class="titleClass">故障状态</span>
              <template v-if="monitorType11026 == 'true'">
                <span class="statusClass fault"> 故障 </span>
              </template>
              <template v-else>
                <span class="statusClass autoHand"> 正常 </span>
              </template>
            </div>

            <div>
              <span class="titleClass">风机控制</span>
              <template v-if="monitorType11028 == 'true'">
                <span class="statusBorder" @click="showInner('11028', false)"> 停止 </span>
              </template>
              <template v-else>
                <span class="statusBorder" @click="showInner('11028', true)"> 启动 </span>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div style="height: 216px">
        <div style="float: left; padding: 20px; width: 50%">
          <img src="../../../../../../../assets/images/speed-wind.png" />
          <p>
            <span style="margin-left: 20px; margin-right: 10px">运行状态:</span>
            <template v-if="monitorType11030 == 'true'">
              <span class="statusClass autoHand"> 运行 </span>
            </template>
            <template v-else>
              <span class="statusClass stop"> 停止</span>
            </template>
          </p>
        </div>
        <div style="float: left; width: 50%; height: 216px">
          <div class="collectingWell-c-r speedWind-c-r fl">
            <div>
              <span class="titleClass">手自动状态</span>
              <template v-if="monitorType11031 == 'true'">
                <span class="statusClass autoHand"> 自动 </span>
              </template>
              <template v-else>
                <span class="statusClass stop"> 手动 </span>
              </template>
            </div>
            <div>
              <span class="titleClass">故障状态</span>
              <template v-if="monitorType11032 == 'true'">
                <span class="statusClass fault"> 故障 </span>
              </template>
              <template v-else>
                <span class="statusClass autoHand"> 正常 </span>
              </template>
            </div>

            <div>
              <span class="titleClass">风机控制</span>
              <template v-if="monitorType11033 == 'true'">
                <span class="statusBorder" @click="showInner('11033', false)"> 停止 </span>
              </template>
              <template v-else>
                <span class="statusBorder" @click="showInner('11033', true)"> 启动 </span>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { setPoint } from '@/api/business/base/tenant/map'
export default {
  name: 'ExhaustFan',
  props: {
    // //是否显示
    exhaustFanGroupDialogVisible: {
      type: Boolean
    },
    // 设备信息
    deviceInfo: {
      type: Object,
    },
    // 设备类型编码
    deviceType: {
      type: String,
    },
  },
  computed: {
    telecommandMessage() {
      return this.$store.getters.telecommandMessage;
    },
    telemeteringMessage() {
      return this.$store.getters.telemeteringMessage;
    },
    isShow() {
      return this.exhaustFanGroupDialogVisible;
    }
  },
  watch: {
    //侦听遥信数据
    telecommandMessage(message) {
      this.telecommandMessageInfo(message);
    },
    //侦听遥测数据
    telemeteringMessage(message) {
      this.telemeteringMessageInfo(message);
    },
    isShow: function () {
      this.isShowDialog();
    }
  },
  data() {
    return {
      // dialogVisible:false,
      currentDeviceType: '110001',
      monitorType11025: null,
      monitorType11028: null,
      monitorType11026: null,
      monitorType013001: null,
      monitorType11030: null,
      monitorType11032: null,
      monitorType11031: null,
      monitorType11033: null,
      monitorType007003: null,
      control: false,
      timer: null,
      innerVisible: false,
      historyTable: []
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    isShowDialog() {
      if (this.exhaustFanGroupDialogVisible) {
        this.initMonitorRedisData();
      }
    },
    initMonitorRedisData() {
      this.historyTable = []
      this.deviceInfo.monitorList.map(v => {
        this.findMonitorTypeValue(v.monitorType);
      })
    },
    findMonitorTypeValue(monitorType) {
      let monitorObj = this.deviceInfo.monitorList.find((item) => {
        return item.monitorType == monitorType;
      })
      if (parseInt(monitorType) === 10000) {
        this.historyTable.push(monitorObj.historyTable)
      }
      this["monitorType" + monitorType] = monitorObj.value;


    },
    findSourceCodeValue(message) {
      if (this.deviceInfo != null) {
        let monitorObj = this.deviceInfo.monitorList.find((item) => {
          return item.historyTable == message.sourceCode;
        })
        if (monitorObj != undefined) {
          this["monitorType" + monitorObj.monitorType] = message.value;

        }
      }
    },
    closeExhaustFanDialog() {
      this.$emit('update:deviceType', null)
      this.$emit('update:exhaustFanGroupDialogVisible', false)
    },
    //遥信
    telecommandMessageInfo(message) {
      this.findSourceCodeValue(message);
    },
    //遥测
    telemeteringMessageInfo(message) {
      this.findSourceCodeValue(message);
    },
    controlPoint(monitorType, value) {
      // this.$emit('change', true)
      if (this.deviceInfo != null) {
        let monitorObj = this.deviceInfo.monitorList.find((item) => {
          return item.monitorType == monitorType;
        })
        setPoint({ "sourceCode": monitorObj.historyTable, "value": value })
      }
    },
    showInner(monitorType, value) {
      this.$confirm('确认是否状态切换?', '设备状态切换', {
        confirmButtonText: '确认',
        cancelButtonText: '关闭',
        type: 'warning',
        center: true
      }).then(() => {
        this.controlPoint(monitorType, value)
      }).catch(() => {

      });
    }
  }
}
</script>

<style scoped>
.content {
  display: grid;
  grid-template-columns: 50% 50%;
}
.titleClass {
  display: inline-block;
  height: 28px;
  line-height: 28px;
  min-width: 103px;
  text-align: right;
  margin-right: 10px;
}
.statusClass {
  display: inline-block;
  width: 75px;
  height: 28px;
  text-align: center;
  line-height: 28px;
  color: #fff;
  background-color: #20ebb6;
  margin-right: 10px;
  border-radius: 4px;
}
.statusBorder {
  cursor: pointer;
  display: inline-block;
  width: 75px;
  height: 26px;
  text-align: center;
  line-height: 22px;
  border: 2px solid #00b050;
  margin-right: 10px;
  border-radius: 4px;
}
.collectingWell-c-r {
  margin-top: 20px;
}
.collectingWell-c-r > div {
  height: 28px;
  margin-bottom: 20px;
}
.active {
  background-color: #bcd0d5;
}
.black {
  background-color: #333;
}
.autoHand {
  background-color: rgb(143, 170, 220);
}
.fault {
  background-color: #f43d3d;
}
.point {
  cursor: pointer;
}
.stop {
  background-color: rgb(217, 217, 217);
}
.btn {
  margin-left: 10px;
}
</style>
